@if (!isFromHomePage) {
<div class="relative">
  <div [hidden]="showZeroState">
    <canvas baseChart class="chart" [data]="barChartData" [options]="barChartOptions" [type]="barChartType" style="max-height: 180px" height="180px">
    </canvas>
  </div>

  @if (showZeroState) {
  <div class="w-full h-[160px] text-center">
    <img src="assets/reports/report_empty_state.svg" class="w-[99%]" />
  </div>
  }
</div>
}@else {
  <div class="relative">
    <div [hidden]="showZeroState">
      <canvas baseChart class="chart" [data]="barChartData" [options]="barChartOptions" [type]="barChartType" style="max-height: 299px" height="299px">
      </canvas>
    </div>
  
    @if (showZeroState) {
    <div class="w-full h-[299px] text-center">
      <img src="assets/reports/report_empty_state.svg" class="w-full h-full" />
    </div>
    }
  </div>
}
